(function () {
  'use strict';
  var reviewPaths = {
    '/products/artwork-digitization': '/pages/original-artwork-scanning',
    '/products/giclee-fine-art-prints-908c1cae13': '/products/giclee-fine-art-prints',
    '/products/giclee-fine-art-prints-e2e8281ac5': '/products/giclee-fine-art-prints',
    '/products/giclee-fine-art-prints-f8c0fb081a': '/products/giclee-fine-art-prints',
    '/products/giclee-fine-art-prints-4a1491e9a5': '/products/giclee-fine-art-prints'
  };
  var scrollSelector = '.pfh__table-wrap, .sh-pricing__table-wrap, .test-print-pricing__table-wrap, .ep-table-wrap, [class*="ai-holiday-deadlines__table-wrapper"], .ep-table-wrap table, .rte table';
  function accessibleTables() {
    document.querySelectorAll(scrollSelector).forEach(function (region) {
      var overflowing = region.scrollWidth > region.clientWidth + 1;
      if (overflowing && !region.hasAttribute('tabindex')) {
        region.tabIndex = 0;
        region.setAttribute('data-stackhouse-scroll-focus', '');
        if (region.tagName !== 'TABLE') {
          var caption = region.querySelector('caption');
          region.setAttribute('role', 'region');
          region.setAttribute('aria-label', caption ? caption.textContent.trim() : 'Scrollable comparison table');
        }
      } else if (!overflowing && region.hasAttribute('data-stackhouse-scroll-focus')) {
        region.removeAttribute('tabindex');
        region.removeAttribute('data-stackhouse-scroll-focus');
      }
    });
  }
  function repairReviewLinks(scope) {
    scope.querySelectorAll('a[href]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), location.origin);
        var replacement = url.origin === location.origin && reviewPaths[url.pathname.replace(/\/$/, '')];
        if (replacement) link.setAttribute('href', replacement);
      } catch (error) { /* Ignore invalid third-party URLs. */ }
    });
  }
  function ready() {
    accessibleTables();
    // Slick's listbox/option semantics conflict with links inside these content slides.
    document.querySelectorAll('.slideshow, .product-slideshow').forEach(function (carousel) {
      function labelContentSlides() {
        carousel.querySelectorAll('.slick-track[role="listbox"]').forEach(function (track) {
          track.setAttribute('role', 'group');
          track.setAttribute('aria-label', carousel.classList.contains('product-slideshow') ? 'Product images' : 'Slideshow');
        });
        carousel.querySelectorAll('.slick-slide[role="option"]').forEach(function (slide) {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
        });
      }
      labelContentSlides();
      new MutationObserver(labelContentSlides).observe(carousel, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['role']
      });
    });
    if (location.pathname === '/pages/the-stackhouse-reviews') {
      var main = document.querySelector('main') || document.body;
      repairReviewLinks(main);
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            repairReviewLinks(node.parentElement || main);
          });
        });
      }).observe(main, { childList: true, subtree: true });
    }
    if (/^\/pages\/(background-removal|border-mat-generator|cmyk-converter)\/?$/.test(location.pathname)) {
      document.documentElement.classList.add('stackhouse-image-tool-active');
      if (window.StackhouseMarketingPopupGuard) window.StackhouseMarketingPopupGuard.acquire('public-image-tool');
    }
  }
  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(accessibleTables, 100); });
  document.addEventListener('toggle', accessibleTables, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
